import React from "react";
// core components
import { TEXTS } from "../../constants"
import { PromotionHeadline } from "molecules";
import { Card, StrictGrid, AsymetricGrid } from "organisms";

import "./styles.scss";

const sessionsImage = require("../../assets/icons/sessions/light.png");
const contributeImage = require("../../assets/icons/contribute/Developer.png");
const sessionCards = require("../../assets/icons/features/Session.png");
const songsImage = require("../../assets/icons/features/Songs.png");

export default props => (
  <div className="home-page">
    <Card h1={TEXTS.MAIN_CARD_TITLE} 
          h5={TEXTS.MAIN_CARD_SUBTITLE}
          purchaseAction={ _ => window.location.href = TEXTS.APP_URL}
          image={sessionsImage}
          showBuyMeACoffee
          showScroll/>
    <StrictGrid title={TEXTS.FEATURES_TITLE}
                elements={TEXTS.highlightFeatures}
                image={sessionCards}
                altImage="Session cards placeholder"/>
    <PromotionHeadline headlineTitle={TEXTS.PROMOTION_HEADLINE_TITLE}
                       headlineText={TEXTS.PROMOTION_HEADLINE_TEXT}
                       image={songsImage}>
      <AsymetricGrid elements={TEXTS.promotionElements}/>
    </PromotionHeadline>
    <Card id="contribute-card"
          h3={TEXTS.CONTRIBUTE_H3}
          h1={TEXTS.CONTRIBUTE_H1} 
          h5={TEXTS.CONTRIBUTE_H5}
          image={contributeImage}
          showBuyMeACoffee/>
  </div>
);
